import { defineStyleConfig } from "@chakra-ui/react"

export const menuTheme = defineStyleConfig({
  baseStyle: props => ({
    list: {
      bg: props.colorMode === "light" ? "white" : "gray.800",
    },
    item: {
      bg: props.colorMode === "light" ? "white" : "gray.800",
      _hover: {
        bg: props.colorMode === "light" ? "gray.50" : "whiteAlpha.100",
      },
    },
  }),
})
